import {
  ACCESS_ALLOWED,
  ACCESS_DENIED,
  DataAccessState,
  InitialState,
  PrivateRouteValidation,
  VERIFYINNG_ACCESS_PERMISSION,
} from './types'

const PrivateRouteReducer = (
  state: DataAccessState = InitialState,
  action: PrivateRouteValidation
): DataAccessState => {
  switch (action.type) {
    case VERIFYINNG_ACCESS_PERMISSION:
      return {
        ...state,
        isVerifying: true,
      }
    case ACCESS_DENIED:
      return {
        ...state,
        accessDenied: action.payload,
        accessAllowed: false,
        isVerifying: false,
      }
    case ACCESS_ALLOWED:
      return {
        ...state,
        accessDenied: false,
        accessAllowed: action.payload,
        isVerifying: false,
      }
    default:
      return state
  }
}
export default PrivateRouteReducer
